/* FundOurKids By State — state-card grid filtering.
 *
 * The 50 cards are rendered server-side by sections/fok-bystate-states.liquid
 * from snippets/fok-states-data.liquid, so the grid is complete at first paint
 * and a /pages/by-state#nav-grader link lands on the grader (client feedback
 * 2026-09-25, FOK-01). This file only filters those cards, the design's
 * `shownStates` / `resultLine` bindings: the search box matches name or
 * abbreviation, the pills match the grade's first letter.
 *
 * A card click selects that state in the grader's dropdown and scrolls to
 * #nav-grader (client feedback 2026-09-25, FOK-06).
 *
 * Style follows assets/fok.js: one IIFE, no framework, no libraries, and a
 * DOM-ready init that is idempotent.
 */
(function (window, document) {
  'use strict';

  /* Search matches name OR abbreviation, case-insensitive. The filter matches
     the FIRST letter of the grade (so "D" also matches "D+" and "F", exactly
     as the design's Grade D/F pill does); 'all' matches everything. */
  function matches(state, query, filter) {
    var q = query;
    if (q) {
      var name = String(state.name || '').toLowerCase();
      var ab = String(state.ab || '').toLowerCase();
      if (name.indexOf(q) === -1 && ab.indexOf(q) === -1) return false;
    }
    if (filter && filter !== 'all') {
      var first = String(state.grade || '').charAt(0).toUpperCase();
      if (filter === 'D') {
        if (first !== 'D' && first !== 'F') return false;
      } else if (first !== filter) {
        return false;
      }
    }
    return true;
  }

  function resultLine(shown, total) {
    if (shown === total) return 'Showing all ' + total + ' states.';
    return 'Showing ' + shown + ' of ' + total + ' states.';
  }

  /* The grader re-renders on its select's input/change events. */
  function selectState(name) {
    var select = document.querySelector('[data-fok-grader] [data-fok-g="state"]');
    if (!select) return;
    select.value = name;
    select.dispatchEvent(new Event('input', { bubbles: true }));
    select.dispatchEvent(new Event('change', { bubbles: true }));
    var grader = document.getElementById('nav-grader');
    if (grader) grader.scrollIntoView({ behavior: 'smooth', block: 'start' });
  }

  function initRoot(root) {
    if (root.getAttribute('data-fok-states-ready') === '1') return;
    root.setAttribute('data-fok-states-ready', '1');

    var grid = root.querySelector('[data-fok-states-grid]');
    var countEl = root.querySelector('[data-fok-states-count]');
    var searchEl = root.querySelector('[data-fok-states-search]');
    var buttons = root.querySelectorAll('[data-fok-states-filter]');
    if (!grid) return;

    grid.addEventListener('click', function (event) {
      var card = event.target.closest('[data-state-name]');
      if (card && grid.contains(card)) selectState(card.getAttribute('data-state-name'));
    });

    var cards = grid.querySelectorAll('[data-state-name]');
    var states = [];
    for (var c = 0; c < cards.length; c++) {
      states.push({
        el: cards[c],
        name: cards[c].getAttribute('data-state-name'),
        ab: cards[c].getAttribute('data-state-abbr'),
        grade: cards[c].getAttribute('data-grade')
      });
    }
    var query = '';
    var filter = 'all';

    function render() {
      var shown = 0;
      for (var i = 0; i < states.length; i++) {
        var visible = matches(states[i], query, filter);
        states[i].el.hidden = !visible;
        if (visible) shown++;
      }
      if (countEl) countEl.textContent = resultLine(shown, states.length);
    }

    if (searchEl) {
      searchEl.addEventListener('input', function () {
        query = String(searchEl.value || '').trim().toLowerCase();
        render();
      });
    }

    for (var b = 0; b < buttons.length; b++) {
      (function (button) {
        button.addEventListener('click', function () {
          filter = button.getAttribute('data-fok-states-filter') || 'all';
          for (var j = 0; j < buttons.length; j++) {
            buttons[j].setAttribute('data-on', buttons[j] === button ? '1' : '0');
          }
          render();
        });
      })(buttons[b]);
    }
  }

  function init() {
    var roots = document.querySelectorAll('[data-fok-states]');
    for (var i = 0; i < roots.length; i++) initRoot(roots[i]);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }

  /* Theme-editor re-render: a section reload replaces the markup, so re-init. */
  document.addEventListener('shopify:section:load', init);

  window.FOKByState = {
    selectState: selectState,
    matches: matches,
    resultLine: resultLine
  };
})(window, document);
